import { last, objOf } from "ramda"

import { Atom } from "@cirrus/fe-lib"

import { core } from "../_params.js"
import { CurrentUser, Customer, Notifications, Skins } from "../entities/index.js"
import { CoreConfig } from "../shared/config/index.js"

export const WrappedAtom = objOf(
  last(core.domain.path),

  Atom.combined({
    entities: Atom.from(CurrentUser, Customer, Notifications, Skins),
    shared: Atom.from(CoreConfig),
  }),
)
